module.exports = __webpack_public_path__ + "static/media/SmartAutomation2_EN.5249123e.png";